import { render, staticRenderFns } from "./newDesc2.vue?vue&type=template&id=1f4ab27e&scoped=true"
import script from "./newDesc2.vue?vue&type=script&lang=js"
export * from "./newDesc2.vue?vue&type=script&lang=js"
import style0 from "./newDesc2.vue?vue&type=style&index=0&id=1f4ab27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ab27e",
  null
  
)

export default component.exports